import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../modules/driverActions'
import * as api from '../api/drivers'

function* fetchDrivers(action) {
  try {
    const payload = yield call(api.getDriverList, action)
    yield put({ type: constants.DRIVERLIST_REFRESH.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DRIVERLIST_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

/**
 * Saga
 */
function* driverListRefresh() {
  yield takeLatest(constants.DRIVERLIST_REFRESH.ACTION, fetchDrivers)
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([fork(driverListRefresh)])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/driverSaga.js